module.exports = ".main-content-container {\n  padding: 10px; }\n\n.close {\n  position: absolute;\n  right: 10px;\n  top: 10px; }\n"